import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateLicenseFratSubForm = document.createElement('template');

templateLicenseFratSubForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='title' id='frat-product-details-title'></gz-title>

    <section id='frat-product-details'>
      <span class='module-info-text'>
        <span id='frat-product-details-text'></span>
        <gz-link id='frat-product-details-link' type='underline' color='primary'></gz-link>
      </span>
    </section>
  </div>
`;
